import React from "react";
import * as Fathom from "fathom-client";
import Button from "components/CustomButtons/Button.js";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";

export function ShareButtons({ english, isEmailSection, width }) {
  const shareUrl = english
    ? "https://wtools.fagforbundet.no/oljefondet/en"
    : "https://wtools.fagforbundet.no/oljefondet/";
  const twitterHashtags = english
    ? ["Icare", "divestfromoccupation"]
    : ["oljefondkampanje", "jegbryrmeg", "fagforbundet", "norskfolkehjelp"];
  const twitterTitle = english
    ? "The Norwegian oil fund is investing in the occupation of Palestine. I care. Do you?"
    : "Oljefondet investerer i okkupasjonen av Palestina. Jeg bryr meg, gjør du?";
  const facebookQuote = english
    ? "The Norwegian oil fund is investing in the occupation of Palestine. I care. Do you? #Icare #divestfromoccupation"
    : "Oljefondet investerer i okkupasjonen av Palestina. Jeg bryr meg, gjør du? \n#jegbryrmeg #fagforbundet #norskfolkehjelp";

  if (isEmailSection) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "left",
          flexDirection: "row",
          marginTop: "5vh",
        }}
      >
        <TwitterShareButton
          url={shareUrl}
          hashtags={twitterHashtags}
          title={twitterTitle}
          style={{ marginRight: "5px" }}
        >
          <Button
            onClick={() => Fathom.trackGoal("XOQFQHAU", 0)}
            style={{ backgroundColor: "#00acee", color: "white" }}
          >
            {width > 500
              ? english
                ? "Share this campaign"
                : "Del denne kampanjen "
              : ""}
            <TwitterIcon style={{ color: "white" }} size={32} />
          </Button>
        </TwitterShareButton>
        <FacebookShareButton
          url={shareUrl}
          hashtag={"#oljefondkampanje"}
          quote={facebookQuote}
          style={{ marginLeft: "5px" }}
        >
          <Button
            onClick={() => Fathom.trackGoal("1L6QTKLJ", 0)}
            style={{ backgroundColor: "#3b5998", color: "white" }}
          >
            {width > 500
              ? english
                ? "Share this campaign"
                : "Del denne kampanjen "
              : ""}
            <FacebookIcon style={{ color: "white" }} size={32} />
          </Button>
        </FacebookShareButton>
      </div>
    );
  } else {
    return (
      <>
        <TwitterShareButton
          url={shareUrl}
          hashtags={twitterHashtags}
          title={twitterTitle}
          style={{ marginRight: "5px" }}
        >
          <Button justIcon style={{ backgroundColor: "#00acee" }}>
            <TwitterIcon size={32} />
          </Button>
        </TwitterShareButton>
        <FacebookShareButton
          url={shareUrl}
          hashtag={"#oljefondkampanje"}
          quote={facebookQuote}
          style={{ marginRight: "5px" }}
        >
          <Button justIcon style={{ backgroundColor: "#3b5998" }}>
            <FacebookIcon size={32} />
          </Button>
        </FacebookShareButton>
      </>
    );
  }
}
